// extracted by mini-css-extract-plugin
export default {"scrollable":"_1EfVj3-5M845g--grdzYik","firstClick":"_2kbBdnQCWo_Zx_ndENQbNS"};